{
    "productDashboard": {
        "common": {
            "last": "Laatste",
            "for": "Voor",
            "days": "dagen",
            "day": "dag",
            "categories": "categorieën",
            "open": "Open",
            "inProgress": "In behandeling",
            "inProgressShort": "In behand.",
            "resolved": "Opgelost",
            "clear": "Wissen",
            "selected": "selected",
            "clearAllFilters": "Alle filters wissen"
        },
        "shell": {
            "dataUpdated": "Gegevens bijgewerkt",
            "latestTurn": "laatste interactie",
            "records": "records",
            "ofData": "aan gegevens",
            "syncing": "Synchroniseren…",
            "refresh": "↻ Gegevens vernieuwen",
            "dataRefreshed": "Gegevens vernieuwd.",
            "syncFailed": "Synchronisatie kon niet worden gestart.",
            "syncCompletedWithErrors": "Synchronisatie voltooid met fouten:",
            "timeRangeAria": "Tijdsbereik",
            "overview": "Overzicht",
            "myhelpData": "van MyHelp-gegevens",
            "rangeLabel": "Bereik",
            "rangeAria": "Aangepast datumbereik",
            "rangeFrom": "Van",
            "rangeTo": "Tot",
            "rangeApplyAria": "Datumbereik toepassen",
            "rangeClearAria": "Datumbereik wissen",
            "rangeSelectBoth": "Selecteer zowel een begin- als einddatum.",
            "rangeInvalidOrder": "De begindatum moet vóór de einddatum liggen.",
            "rangeTooWide": "Selecteer een bereik van maximaal",
            "dateRangeCaption": "Datumbereik"
        },
        "overview": {
            "greetingMorning": "Goedemorgen",
            "greetingAfternoon": "Goedemiddag",
            "greetingEvening": "Goedenavond",
            "greetingNight": "Goedenacht",
            "subtitle": "Dit gebeurt er vandaag bij uw producten.",
            "tabOverview": "Overzicht",
            "tabActionsForYou": "Acties voor u",
            "actionsTitle": "Acties voor u",
            "actionsMeta": "Aanbevolen volgende stappen voor het productteam",
            "kpiTotalQueries": "TOTAAL AANTAL VRAGEN",
            "kpiIncidentsRaised": "GEMELDE INCIDENTEN (Sinds 10 september)",
            "kpiUpcoming": "AANKOMENDE FUNCTIE",
            "kpiCallback": "TERUGBELVERZOEKEN (Sinds 10 september)",
            "kpiLiveChat": "LIVE-CHATVERZOEKEN (Sinds 10 september)",
            "viewBreakdown": "Uitsplitsing →",
            "viewAllIncidents": "Alle incidenten →",
            "upcomingTitle": "Nieuwe functie binnenkort beschikbaar",
            "upcomingSub": "Meer productinzichten zijn onderweg.",
            "topCategories": "Meest voorkomende vraagcategorieën",
            "viewAll": "Alles bekijken →",
            "tipQueries": "Vragen",
            "uniqueUsersTitle": "Unieke gebruikers",
            "detailedView": "Gedetailleerd overzicht",
            "usersPerDay": "Unieke gebruikers per dag",
            "usersPerWeek": "Unieke gebruikers per week",
            "usersPerMonth": "Unieke gebruikers per maand",
            "uniqueUsersTrendTooltipLead": "Vergelijkt",
            "uniqueUsersTrendTooltipConnector": "met",
            "kpiTooltips": {
                "totalQueries": "Totaal aantal vragen ontvangen over alle producten binnen de geselecteerde periode.",
                "incidentsRaised": "Incidenten gemeld vanuit chatbotgesprekken, uitgesplitst naar status.",
                "upcoming": "Er komt een nieuwe dashboardfunctie aan — kom binnenkort terug.",
                "callback": "Terugbelverzoeken ingediend door gebruikers, uitgesplitst naar taal.",
                "liveChat": "Live-chatverzoeken ingediend door gebruikers, uitgesplitst naar taal.",
                "feedbackCoverage": "Aandeel van het totaal aantal vragen waarop gebruikersfeedback is ontvangen (👍 of 👎)."
            }
        },
        "totalQueries": {
            "title": "Inzichten in totaal aantal vragen",
            "queries": "vragen",
            "vsPrior": "ten opzichte van de vorige periode",
            "chartTitle": "Vragen per categorie",
            "breakdownTitle": "Uitsplitsing per categorie",
            "thCategory": "CATEGORIE",
            "thQueries": "VRAGEN",
            "thShare": "AANDEEL",
            "thDistribution": "VERDELING",
            "tipQueries": "Vragen",
            "tipShare": "Aandeel %",
            "searchPlaceholder": "Zoeken",
            "matchesSuffix": "treffers",
            "matchSuffix": "treffer"
        },
        "incidents": {
            "title": "Probleemcategorieën",
            "incidents": "incidenten",
            "thId": "ID",
            "thIssue": "VRAAG / PROBLEEM",
            "thCategory": "CATEGORIE",
            "thProduct": "PRODUCT",
            "thCompany": "BEDRIJF",
            "thSeverity": "ERNST",
            "thStatus": "STATUS",
            "empty": "Geen MyHelp-incidenten in deze periode.",
            "severityHigh": "Hoog",
            "severityMedium": "Gemiddeld",
            "severityLow": "Laag",
            "incident": "incident",
            "breakdownTitle": "Categorie-uitsplitsing",
            "thIncidents": "INCIDENTEN",
            "thShare": "AANDEEL",
            "thDistribution": "VERDELING",
            "searchPlaceholder": "Zoeken",
            "matchesSuffix": "treffers",
            "matchSuffix": "treffer"
        },
        "incidentCategory": {
            "titlePrefix": "Incidenten in",
            "loadError": "Kan incidenten niet laden.",
            "incident": "incident",
            "incidents": "incidenten",
            "closeAria": "Sluiten",
            "thDate": "DATUM",
            "empty": "Geen incidenten gevonden voor deze categorie.",
            "loading": "Laden…",
            "loadMorePrefix": "Meer laden (toont",
            "of": "van"
        },
        "userSentiment": {
            "title": "Inzichten in gebruikersfeedback",
            "summaryLikes": "likes",
            "summaryDislikes": "dislikes",
            "last": "Laatste",
            "days": "dagen",
            "likes": "Likes",
            "dislikes": "Dislikes",
            "chartTitle": "Likes versus dislikes per categorie",
            "detailTitle": "Feedbackdetails per categorie",
            "positive": "Positief",
            "thingsWell": "Wat goed ging",
            "thingsAttention": "Wat aandacht nodig heeft",
            "askAiHint": "Vraag het de AI-assistent (opent in een nieuw tabblad)",
            "searchPlaceholder": "Zoeken",
            "matchesSuffix": "treffers",
            "matchSuffix": "treffer"
        },
        "products": {
            "title": "Productcategorieën",
            "products": "producten",
            "queryVolume": "Aantal vragen",
            "incidents": "Incidenten",
            "sentiment": "Sentiment",
            "healthScore": "Gezondheidsscore"
        },
        "companyFilter": {
            "allCompanies": "Alle bedrijven",
            "allCompaniesShort": "Alle bedrijven",
            "selectedSuffix": "bedrijven geselecteerd",
            "filterAria": "Filteren op bedrijf",
            "searchPlaceholder": "Bedrijven zoeken…",
            "noMatchPrefix": "Geen bedrijven komen overeen"
        },
        "clusterFilter": {
            "allClusters": "Alle clusters",
            "allClustersShort": "Alle clusters",
            "selectedSuffix": "clusters geselecteerd",
            "filterAria": "Filteren op cluster",
            "searchPlaceholder": "Clusters zoeken…",
            "noMatchPrefix": "Geen clusters komen overeen"
        },
        "categoryFilter": {
            "allCategories": "Alle categorieën",
            "selectedSuffix": "categorieën geselecteerd",
            "filterAria": "Filteren op categorie",
            "searchPlaceholder": "Categorieën zoeken…",
            "allCategoriesShort": "Alle categorieën",
            "selectedShort": "geselecteerd",
            "clear": "Wissen",
            "noMatchPrefix": "Geen categorieën komen overeen met"
        },
        "categoryQueries": {
            "like": "Vind ik leuk",
            "dislike": "Vind ik niet leuk",
            "titlePrefix": "Vragen in",
            "loadError": "Vragen konden niet worden geladen.",
            "query": "vraag",
            "queries": "vragen",
            "preparing": "Voorbereiden…",
            "downloadExcel": "⬇ Excel downloaden",
            "closeAria": "Sluiten",
            "thQuery": "VRAAG",
            "thSentiment": "SENTIMENT",
            "thDate": "DATUM",
            "thSource": "BRON",
            "thLanguage": "TAAL",
            "thCompany": "BEDRIJF",
            "colQuery": "Vraag",
            "colSentiment": "Sentiment",
            "colDate": "Datum",
            "colSource": "Bron",
            "colLanguage": "Taal",
            "colCompany": "Bedrijf",
            "empty": "Geen vragen gevonden voor deze categorie.",
            "loading": "Laden…",
            "loadMorePrefix": "Meer laden (toont",
            "of": "van",
            "sortSentimentHint": "Klik om op sentiment te sorteren",
            "sortDateHint": "Klik om op datum te sorteren"
        },
        "feedbackPie": {
            "likes": "Likes",
            "dislikes": "Dislikes",
            "noFeedback": "Geen feedback",
            "coverage": "FEEDBACKDEKKING",
            "meta": "van het totaal aantal vragen",
            "feedback": "feedback",
            "noData": "Geen gegevens",
            "viewFeedback": "Gebruikersfeedback →"
        },
        "requestCard": {
            "empty": "Geen verzoeken in deze periode.",
            "breakdown": "Uitsplitsing →"
        },
        "requestBreakdown": {
            "titleCallback": "Terugbelverzoeken — Taaluitsplitsing",
            "titleLiveChat": "Live-chatverzoeken — Taaluitsplitsing",
            "breakdownTitle": "Taaluitsplitsing",
            "thLanguage": "TAAL",
            "thCount": "AANTAL",
            "thShare": "AANDEEL",
            "thDistribution": "VERDELING",
            "language": "taal",
            "languages": "talen",
            "request": "verzoek",
            "requests": "verzoeken",
            "empty": "Geen verzoeken in deze periode."
        },
        "tabError": {
            "title": "Dashboardgegevens konden niet worden geladen",
            "message": "De dataservice heeft niet gereageerd. Probeer het opnieuw — er worden geen gegevens getoond, dus hier wordt niets geschat."
        },
        "actionItems": {
            "knowledgeArticles": {
                "title": "Kennisartikelen maken / bijwerken",
                "hint": "Houd de inhoud van uw product nauwkeurig en actueel",
                "childTitle": "Kennisbank maken en bijwerken",
                "childHint": "Hoe u de kennisbank maakt en bijwerkt."
            },
            "scripts": {
                "title": "Scripts bouwen en implementeren via Nexthink Remote Actions",
                "hint": "Automatiseer het oplossen van het probleem door een remote action op het apparaat van de gebruiker in te schakelen",
                "childTitle": "Link om Nexthink te bestellen",
                "childHint": "Beheer van remote actions"
            }
        }
    }
}
